<template>
    <div>
        <div class="form-group my-2">
            <label
                for="checkout_phone_number"
                class="label-required"
            >
                {{ __('Phone') }}
            </label>
            <phone-number-field
                :fix-country-code="checkoutData.phoneNumberFixCountryCode"
                :country-code="phoneNumber.countryCode"
                :prefix="phoneNumber.prefix"
                :line-number="phoneNumber.lineNumber"
                :errors="errors"
                @input="phoneNumber = $event"
            />
        </div>

        <template v-if="shippable && !selectedShippingModeHasPickupPoints">
            <shipping-address-selector
                v-model="shippingAddress"
                :addresses="shippingAddresses"
            />
            <form-error
                :errors="errors"
                field="shippingAddressId"
                style="display: block"
            />
        </template>

        <billing-address-selector
            v-model="billingAddress"
            :addresses="billingAddresses"
        />
        <form-error
            :errors="errors"
            field="billingAddressId"
            style="display: block"
        />
    </div>
</template>

<script>
import authenticatedCustomerDataBase from '../../../../mixins/checkout/authenticatedCustomerDataBase'

export default {
    name: 'AuthenticatedCustomerDataForm',
    mixins: [authenticatedCustomerDataBase],
}
</script>
